import { render, staticRenderFns } from "./ReviewListDropdown.vue?vue&type=template&id=a0413d94&scoped=true&v-if=reviewLists.length%3E0&"
import script from "./ReviewListDropdown.vue?vue&type=script&lang=js&"
export * from "./ReviewListDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ReviewListDropdown.vue?vue&type=style&index=0&id=a0413d94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0413d94",
  null
  
)

export default component.exports